const translation = {
    "customers": "לקוחות",
    "areYouSureDeleteCustomer": "האם אתה בטוח שברצונך למחוק לקוח זה?",
    "customerDeletedSuccess": "הלקוח נמחק בהצלחה",
    "errorOccurred": "ארעה שגיאה",
    "name": "שם",
    "customerCode": "קוד לקוח",
    "customerType": "סוג לקוח",
    "orderingCustomer": "לקוח מזמין",
    "receivingCustomer": "לקוח מקבל",
    "yes": "כן",
    "no": "לא",
    "deleteCustomer": "מחק לקוח"
  }
  export default translation;